import gql from 'graphql-tag';
const LEFT_IMAGE_SENTENCES_ACTIVITY_FRAGMENT = gql `
  fragment LeftImageSentencesActivityFragment on LeftImageSentencesActivity {
    rounds {
      id
      optionalTitle: title
      textSize
      contentImage {
        id
        image {
          description
          id
          src
        }
      }
      steps {
        id
        answer
      }
    }
  }
`;
export default LEFT_IMAGE_SENTENCES_ACTIVITY_FRAGMENT;
